import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";

import BannerManager from "./BannerManager";
import CarsManager from "./CarsManager";
import CommentsManager from "./CommentsManager";
import RatingsManager from "./RatingManager";
import UsersManager from "./UsersManager";
import TermeniManager from "./TermeniManager";
import ConditiiManager from "./ConditiManager";
import ServiciiManager from "./ServiciiManager";
import DespreManager from "./DespreManager";
import ReservationManager from "./ReservationManage";

import "../../styles/admin/SR_AdminMenu.css"; // ✅ nou

const Meniul = () => {
  const [activeComponent, setActiveComponent] = useState("BannerManager");
  const [showTermsList, setShowTermsList] = useState(false);

  const componentsMap = useMemo(
    () => ({
      BannerManager: { title: "Banner Management", component: <BannerManager /> },
      CarsManager: { title: "Editarea Mașinilor", component: <CarsManager /> },
      CommentsManager: { title: "Editarea Comentariilor", component: <CommentsManager /> },
      RatingsManager: { title: "Editarea Ratingurilor", component: <RatingsManager /> },
      ReservationManager: { title: "Rezervări", component: <ReservationManager /> },
      ServiciiManager: { title: "Editarea Serviciilor", component: <ServiciiManager /> },
      UsersManager: { title: "Editarea Utilizatorilor", component: <UsersManager /> },
      DespreManager: { title: "Editarea «Despre Noi»", component: <DespreManager /> },
      TermeniManager: { title: "Editarea Termenilor", component: <TermeniManager /> },
      ConditiiManager: { title: "Editarea Condițiilor", component: <ConditiiManager /> },
    }),
    []
  );

  const current = componentsMap[activeComponent];

  const btn = (name) =>
    `sr-adminMenu__btn ${activeComponent === name ? "is-active" : ""}`;

  const subBtn = (name) =>
    `sr-adminMenu__subBtn ${activeComponent === name ? "is-active" : ""}`;

  const isTermsActive =
    activeComponent === "TermeniManager" || activeComponent === "ConditiiManager";

  return (
    <div className="sr-adminMenu__row">
      {/* LEFT SIDEBAR */}
      <aside className="sr-adminMenu__sidebar">
        <div className="sr-adminMenu__panel">
          <h1 className="sr-adminMenu__title">
            Settings
            <FontAwesomeIcon icon={faCog} className="sr-adminMenu__icon" />
          </h1>

          <div className="sr-adminMenu__btnGroup">
            <button
              className={btn("BannerManager")}
              onClick={() => setActiveComponent("BannerManager")}
              type="button"
            >
              Banners
            </button>

            <button
              className={btn("CarsManager")}
              onClick={() => setActiveComponent("CarsManager")}
              type="button"
            >
              Cars
            </button>

            <button
              className={btn("CommentsManager")}
              onClick={() => setActiveComponent("CommentsManager")}
              type="button"
            >
              Comments
            </button>

            <button
              className={btn("RatingsManager")}
              onClick={() => setActiveComponent("RatingsManager")}
              type="button"
            >
              Ratings
            </button>

            <button
              className={btn("ReservationManager")}
              onClick={() => setActiveComponent("ReservationManager")}
              type="button"
            >
              Reservation
            </button>

            <button
              className={btn("ServiciiManager")}
              onClick={() => setActiveComponent("ServiciiManager")}
              type="button"
            >
              Servicii
            </button>

            <button
              className={btn("UsersManager")}
              onClick={() => setActiveComponent("UsersManager")}
              type="button"
            >
              Users
            </button>

            <button
              className={btn("DespreManager")}
              onClick={() => setActiveComponent("DespreManager")}
              type="button"
            >
              Despre Noi
            </button>

            <button
              className={`sr-adminMenu__btn ${isTermsActive ? "is-active" : ""}`}
              onClick={() => setShowTermsList((v) => !v)}
              type="button"
              aria-expanded={showTermsList}
            >
              Termeni și Condiții
              <span className={`sr-adminMenu__chev ${showTermsList ? "is-open" : ""}`}>▾</span>
            </button>

            {showTermsList && (
              <ul className="sr-adminMenu__subList">
                <li className="sr-adminMenu__subItem">
                  <button
                    className={subBtn("TermeniManager")}
                    onClick={() => setActiveComponent("TermeniManager")}
                    type="button"
                  >
                    Termeni
                  </button>
                </li>
                <li className="sr-adminMenu__subItem">
                  <button
                    className={subBtn("ConditiiManager")}
                    onClick={() => setActiveComponent("ConditiiManager")}
                    type="button"
                  >
                    Condiții
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </aside>

      {/* RIGHT CONTENT */}
      <main className="sr-adminMenu__content">
        {current?.title && <h1 className="sr-adminMenu__contentTitle">{current.title}</h1>}
        <div className="sr-adminMenu__contentBody">{current?.component}</div>
      </main>
    </div>
  );
};

export default Meniul;